import React from 'react';

// ---- Donut chart (zero-dependency SVG) ----
// data: [{ label, value, color }]
export function DonutChart({ data = [], size = 180, thickness = 26, centerLabel, centerValue }) {
  const total = data.reduce((sum, d) => sum + (d.value || 0), 0);
  const radius = (size - thickness) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * radius;

  let offset = 0;
  const segments = total > 0 ? data.filter(d => d.value > 0).map((d) => {
    const fraction = d.value / total;
    const dash = fraction * circumference;
    const seg = {
      ...d,
      dash,
      gap: circumference - dash,
      dashoffset: -offset,
      pct: Math.round(fraction * 100),
    };
    offset += dash;
    return seg;
  }) : [];

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <g transform={`rotate(-90 ${cx} ${cy})`}>
        {/* track */}
        <circle
          cx={cx} cy={cy} r={radius}
          fill="none" stroke="#eef0f4" strokeWidth={thickness}
        />
        {segments.map((s, i) => (
          <circle
            key={i}
            cx={cx} cy={cy} r={radius}
            fill="none"
            stroke={s.color}
            strokeWidth={thickness}
            strokeDasharray={`${s.dash} ${s.gap}`}
            strokeDashoffset={s.dashoffset}
            strokeLinecap="butt"
          >
            <title>{`${s.label}: ${s.value} (${s.pct}%)`}</title>
          </circle>
        ))}
      </g>
      <text x={cx} y={cy - 4} textAnchor="middle" style={{ fontSize: '1.9rem', fontWeight: 800, fill: '#1f2937' }}>
        {centerValue != null ? centerValue : total}
      </text>
      <text x={cx} y={cy + 18} textAnchor="middle" style={{ fontSize: '0.7rem', fill: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
        {centerLabel || 'Total'}
      </text>
    </svg>
  );
}

// ---- Vertical bar trend (zero-dependency SVG-free, flexbox) ----
// data: [{ label, value }]
export function TrendBars({ data = [], color = '#6366f1', height = 150 }) {
  const max = Math.max(1, ...data.map(d => d.value || 0));
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px', height, paddingTop: '20px' }}>
      {data.map((d, i) => {
        const isLast = i === data.length - 1;
        const barHeight = `${(d.value / max) * 100}%`;
        return (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: '100%', justifyContent: 'flex-end' }}>
            <div style={{ fontSize: '0.8rem', fontWeight: 700, color: isLast ? color : '#6b7280', marginBottom: '4px' }}>
              {d.value}
            </div>
            <div
              title={`${d.label}: ${d.value}`}
              style={{
                width: '100%',
                maxWidth: '34px',
                height: barHeight,
                minHeight: d.value > 0 ? '4px' : '0',
                borderRadius: '6px 6px 0 0',
                background: isLast
                  ? `linear-gradient(180deg, ${color}, ${color}cc)`
                  : `${color}66`,
                transition: 'height 0.6s ease',
              }}
            />
            <div style={{ fontSize: '0.72rem', color: '#9ca3af', marginTop: '6px', fontWeight: isLast ? 700 : 400 }}>
              {d.label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
